import React from 'react';
import CreatableSelect from 'react-select/creatable';
import makeAnimated from 'react-select/animated';
import {selectStyles} from '../../utils/StyleUtils';

const animatedComponents = makeAnimated();

interface StateProps {
  change: (selectedOption: any) => void,
  selectedValue: any,
  selectedLabel?: string,
  isDisabled?: boolean,
  style: any,
  options: any,
  control?: any;
  placeholder?: string,
  isClearable?: boolean
}

type Props = StateProps;

export const SingleSelector = ({change, selectedValue, selectedLabel, isDisabled=false, style, options, placeholder = '', control, isClearable = false}: Props) => {
  return <div style={style}>
    <CreatableSelect
      isClearable={isClearable}
      onChange={(selectedOption: any) => {
        change(selectedOption.value);
      }}

      onCreateOption={(value: any) => {
        change(value);
      }}

      isMulti={false}
      value={{value: selectedValue, label: selectedLabel ? selectedLabel : selectedValue}}
      isDisabled={isDisabled}
      components={animatedComponents}
      name="onelight_selector"
      options={options}
      styles={selectStyles({control})}
      placeholder={placeholder}
      className="select-label"
      classNamePrefix="select"
    />
  </div>;
};
